import * as React from "react";
import {ClickAwayListener} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {useState} from "react";


const BlurIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clip-path="url(#clip0_4177_1900)">
                <path
                    d="M7.99967 17.3334C7.26634 17.3334 6.66634 17.9334 6.66634 18.6667C6.66634 19.4 7.26634 20 7.99967 20C8.73301 20 9.33301 19.4 9.33301 18.6667C9.33301 17.9334 8.73301 17.3334 7.99967 17.3334ZM7.99967 22.6667C7.26634 22.6667 6.66634 23.2667 6.66634 24C6.66634 24.7334 7.26634 25.3334 7.99967 25.3334C8.73301 25.3334 9.33301 24.7334 9.33301 24C9.33301 23.2667 8.73301 22.6667 7.99967 22.6667ZM7.99967 12C7.26634 12 6.66634 12.6 6.66634 13.3334C6.66634 14.0667 7.26634 14.6667 7.99967 14.6667C8.73301 14.6667 9.33301 14.0667 9.33301 13.3334C9.33301 12.6 8.73301 12 7.99967 12ZM3.99967 12.6667C3.62634 12.6667 3.33301 12.96 3.33301 13.3334C3.33301 13.7067 3.62634 14 3.99967 14C4.37301 14 4.66634 13.7067 4.66634 13.3334C4.66634 12.96 4.37301 12.6667 3.99967 12.6667ZM7.99967 6.66671C7.26634 6.66671 6.66634 7.26671 6.66634 8.00004C6.66634 8.73337 7.26634 9.33337 7.99967 9.33337C8.73301 9.33337 9.33301 8.73337 9.33301 8.00004C9.33301 7.26671 8.73301 6.66671 7.99967 6.66671ZM27.9997 14C28.373 14 28.6663 13.7067 28.6663 13.3334C28.6663 12.96 28.373 12.6667 27.9997 12.6667C27.6263 12.6667 27.333 12.96 27.333 13.3334C27.333 13.7067 27.6263 14 27.9997 14ZM18.6663 9.33337C19.3997 9.33337 19.9997 8.73337 19.9997 8.00004C19.9997 7.26671 19.3997 6.66671 18.6663 6.66671C17.933 6.66671 17.333 7.26671 17.333 8.00004C17.333 8.73337 17.933 9.33337 18.6663 9.33337ZM18.6663 4.66671C19.0397 4.66671 19.333 4.37337 19.333 4.00004C19.333 3.62671 19.0397 3.33337 18.6663 3.33337C18.293 3.33337 17.9997 3.62671 17.9997 4.00004C17.9997 4.37337 18.293 4.66671 18.6663 4.66671ZM3.99967 18C3.62634 18 3.33301 18.2934 3.33301 18.6667C3.33301 19.04 3.62634 19.3334 3.99967 19.3334C4.37301 19.3334 4.66634 19.04 4.66634 18.6667C4.66634 18.2934 4.37301 18 3.99967 18ZM13.333 27.3334C12.9597 27.3334 12.6663 27.6267 12.6663 28C12.6663 28.3734 12.9597 28.6667 13.333 28.6667C13.7063 28.6667 13.9997 28.3734 13.9997 28C13.9997 27.6267 13.7063 27.3334 13.333 27.3334ZM13.333 4.66671C13.7063 4.66671 13.9997 4.37337 13.9997 4.00004C13.9997 3.62671 13.7063 3.33337 13.333 3.33337C12.9597 3.33337 12.6663 3.62671 12.6663 4.00004C12.6663 4.37337 12.9597 4.66671 13.333 4.66671ZM13.333 9.33337C14.0663 9.33337 14.6663 8.73337 14.6663 8.00004C14.6663 7.26671 14.0663 6.66671 13.333 6.66671C12.5997 6.66671 11.9997 7.26671 11.9997 8.00004C11.9997 8.73337 12.5997 9.33337 13.333 9.33337ZM13.333 16.6667C12.2263 16.6667 11.333 17.56 11.333 18.6667C11.333 19.7734 12.2263 20.6667 13.333 20.6667C14.4397 20.6667 15.333 19.7734 15.333 18.6667C15.333 17.56 14.4397 16.6667 13.333 16.6667ZM23.9997 17.3334C23.2663 17.3334 22.6663 17.9334 22.6663 18.6667C22.6663 19.4 23.2663 20 23.9997 20C24.733 20 25.333 19.4 25.333 18.6667C25.333 17.9334 24.733 17.3334 23.9997 17.3334ZM23.9997 22.6667C23.2663 22.6667 22.6663 23.2667 22.6663 24C22.6663 24.7334 23.2663 25.3334 23.9997 25.3334C24.733 25.3334 25.333 24.7334 25.333 24C25.333 23.2667 24.733 22.6667 23.9997 22.6667ZM23.9997 12C23.2663 12 22.6663 12.6 22.6663 13.3334C22.6663 14.0667 23.2663 14.6667 23.9997 14.6667C24.733 14.6667 25.333 14.0667 25.333 13.3334C25.333 12.6 24.733 12 23.9997 12ZM23.9997 6.66671C23.2663 6.66671 22.6663 7.26671 22.6663 8.00004C22.6663 8.73337 23.2663 9.33337 23.9997 9.33337C24.733 9.33337 25.333 8.73337 25.333 8.00004C25.333 7.26671 24.733 6.66671 23.9997 6.66671ZM27.9997 18C27.6263 18 27.333 18.2934 27.333 18.6667C27.333 19.04 27.6263 19.3334 27.9997 19.3334C28.373 19.3334 28.6663 19.04 28.6663 18.6667C28.6663 18.2934 28.373 18 27.9997 18ZM18.6663 22.6667C17.933 22.6667 17.333 23.2667 17.333 24C17.333 24.7334 17.933 25.3334 18.6663 25.3334C19.3997 25.3334 19.9997 24.7334 19.9997 24C19.9997 23.2667 19.3997 22.6667 18.6663 22.6667ZM18.6663 27.3334C18.293 27.3334 17.9997 27.6267 17.9997 28C17.9997 28.3734 18.293 28.6667 18.6663 28.6667C19.0397 28.6667 19.333 28.3734 19.333 28C19.333 27.6267 19.0397 27.3334 18.6663 27.3334ZM13.333 11.3334C12.2263 11.3334 11.333 12.2267 11.333 13.3334C11.333 14.44 12.2263 15.3334 13.333 15.3334C14.4397 15.3334 15.333 14.44 15.333 13.3334C15.333 12.2267 14.4397 11.3334 13.333 11.3334ZM13.333 22.6667C12.5997 22.6667 11.9997 23.2667 11.9997 24C11.9997 24.7334 12.5997 25.3334 13.333 25.3334C14.0663 25.3334 14.6663 24.7334 14.6663 24C14.6663 23.2667 14.0663 22.6667 13.333 22.6667ZM18.6663 16.6667C17.5597 16.6667 16.6663 17.56 16.6663 18.6667C16.6663 19.7734 17.5597 20.6667 18.6663 20.6667C19.773 20.6667 20.6663 19.7734 20.6663 18.6667C20.6663 17.56 19.773 16.6667 18.6663 16.6667ZM18.6663 11.3334C17.5597 11.3334 16.6663 12.2267 16.6663 13.3334C16.6663 14.44 17.5597 15.3334 18.6663 15.3334C19.773 15.3334 20.6663 14.44 20.6663 13.3334C20.6663 12.2267 19.773 11.3334 18.6663 11.3334Z"
                    fill="#1A1A1A"/>
            </g>
            <defs>
                <clipPath id="clip0_4177_1900">
                    <rect width="32" height="32" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}


export const BackgroundSelect = /* @__PURE__ */ (function BackgroundSelect(
    {
        left,
        bottom,
        room,
        setIsOpen,
        setBackgroundImage,
        backgroundImageIndex,
        setBackgroundImageIndex,
        ...props
    },
) {
    const listPositionStyle = {
        top: bottom ? bottom : 0,
        left: left,
        zIndex: 100,
        width: "416px",
        backgroundColor: 'white',
        borderRadius: "12px",
        padding: "24px",
        gap: "24px",
        alignItems: "flex-start",
        flexDirection: "column",
        boxShadow: "0px 30px 80px 0px rgba(0, 0, 0, 0.15)"
    }

    const handleClick = (index) => {
        if (backgroundImageIndex === index) {
            setBackgroundImageIndex(null);
            setBackgroundImage({isBlur: false, imageUrl: null});
        } else {
            setBackgroundImageIndex(index);
            setBackgroundImage({isBlur: index === 0, imageUrl: index === 0 ? null : imageUrls[index - 1]});
        }
    }

    const BlurBoxStyle = (backgroundImageIndex) => {
        return {
            display: "flex",
            width: "80px",
            height: "80px",
            padding: "10px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "12px",
            border: backgroundImageIndex === 0 ? "2px solid #2B6BFD" : "1.5px solid #1a1a1a",
            cursor: "pointer",
            index: 0,
        }
    }

    const BoxStyle = (imgUrl, index, backgroundImageIndex) => {
        return {
            display: "flex",
            width: "80px",
            height: "80px",
            padding: "10px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
            borderRadius: "12px",
            border: backgroundImageIndex === index ? "2.0px solid #2B6BFD" : "2.0px solid transparent",
            background: `url(${imgUrl}) lightgray 50% / cover no-repeat`,
        }
    }

    const imageUrls = [
        "https://storage.googleapis.com/libretto-public-assets/bk_img_one.jpeg",
        "https://storage.googleapis.com/libretto-public-assets/bk_img_two.jpeg",
        "https://storage.googleapis.com/libretto-public-assets/bk_img_three.jpeg",
        "https://storage.googleapis.com/libretto-public-assets/bk_img_four.jpeg",
        "https://storage.googleapis.com/libretto-public-assets/bk_img_five.jpeg",
        "https://storage.googleapis.com/libretto-public-assets/bk_img_six.jpeg",
    ];

    return (
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
            <ul className="device-list" style={listPositionStyle}>
                <Box style={{display: "flex", flexDirection: "column", gap: "12px"}}>
                    <Box style={{fontFamily: "Inter", fontSize: "14px", fontStyle: "normal", letterSpacing: "0.14px"}}>
                        Blur
                    </Box>
                    <Box style={BlurBoxStyle(backgroundImageIndex)} onClick={() => handleClick(0)}>
                        <BlurIcon/>
                    </Box>
                </Box>
                <div style={{height: "1px", alignSelf: "stretch", background: "#e8e8e8"}}></div>
                <Box style={{display: "flex", flexDirection: "column", gap: "12px"}}>
                    <Box style={{fontFamily: "Inter", fontSize: "14px", fontStyle: "normal", letterSpacing: "0.14px"}}>
                        Image
                    </Box>
                    <Grid container direction="row" style={{display: "flex", gap: "16px", flexDirection: "row"}}>
                        {imageUrls.map((url, index) => (
                            <Box
                                item
                                key={index}
                                style={BoxStyle(url, index + 1, backgroundImageIndex)}
                                onClick={() => handleClick(index + 1)}
                            >
                            </Box>
                        ))}
                    </Grid>
                </Box>
            </ul>
        </ClickAwayListener>
    );
});
